var customSelectors = {
  counters:  document.querySelectorAll('.count'),
  speed: 150,
  juicerFeed: document.getElementById('index-juicer-feed')
};

class customJS {
  constructor() {
    this.bodyElement = document.querySelector("[body-element]");
    if(customSelectors.juicerFeed) this.manageJuicerJS();
    this.bindEvents();
  }
  
  manageJuicerJS(){
    const onIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          let juicer = document.createElement('script');
          juicer.type = 'text/javascript';
          juicer.rel = 'dns-prefetch';
          juicer.src = '//assets.juicer.io/embed.js';
          juicer.defer = true;
          document.body.appendChild(juicer);
          observer.disconnect();
        }
      }
    };
        
    const observer = new IntersectionObserver(onIntersection);
    observer.observe(customSelectors.juicerFeed);
  }

  bindEvents(){
    /* Couter code for protecting-our-outdoors page: */
    customSelectors.counters.forEach( counter => {
      const animate = () => {
        const value = +counter.getAttribute('data-count');
        const data = +counter.innerText;
        const time = value / customSelectors.speed;
        if(data < value) {
          counter.innerText = Math.ceil(data + time);
          setTimeout(animate, 1);
        }else{
          counter.innerText = value;
        } 
      }
      animate();
    });
  }
}

window.onload = () => {
  typeof customJS !== 'undefined' && new customJS();
}